import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ProfileInvoiceAddressComponent } from "./profile-invoice-address.component";
import { ExplanationLabelModule } from "../../../../../../../../../common-ui/src/lib/explanation-label/explanation-label.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzPageHeaderModule } from "ng-zorro-antd/page-header";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzWaveModule } from "ng-zorro-antd/core/wave";
import { TranslateModule } from "@ngx-translate/core";
import { NzInputModule } from "ng-zorro-antd/input";

@NgModule({
  declarations: [ProfileInvoiceAddressComponent],
  imports: [
    CommonModule,
    ExplanationLabelModule,
    FormsModule,
    NzButtonModule,
    NzFormModule,
    NzGridModule,
    NzPageHeaderModule,
    NzSelectModule,
    NzWaveModule,
    ReactiveFormsModule,
    TranslateModule,
    NzInputModule,
  ],
  exports: [ProfileInvoiceAddressComponent],
})
export class ProfileInvoiceAddressModule {}
